import yuri from '../yuri.yeti.png';

export const defaultAuthorImage = yuri;

const hostname = window.location.hostname;
const hostRegexPattarn = /\.(test-|dev-)?genesys\.cloud/;
const matches: RegExpMatchArray | null = hostname.match(hostRegexPattarn);
export const yetiCmsApiHost = `https://yeticms-api${matches ? matches[0] : '.dev-genesys.cloud'}`;
